// Customer data caches live in sessionStorage, so they end with the tab, and are
// cleared on logout. Older builds kept them in localStorage.
const DATA_CACHE_KEYS = ['feedback-list', 'old-feedback-list', 'app-updates'];

export const DATA_CACHE_MAX_AGE_MS = 12 * 60 * 60 * 1000;

export const dataCache = {
    get: (key: string): string | null => {
        try {
            return sessionStorage.getItem(key);
        } catch {
            return null;
        }
    },
    set: (key: string, value: string): void => {
        sessionStorage.setItem(key, value);
    },
};

export const clearDataCaches = (): void => {
    for (const key of DATA_CACHE_KEYS) {
        try {
            sessionStorage.removeItem(key);
            localStorage.removeItem(key);
        } catch {
            // Storage can be unavailable in private browsing.
        }
    }
};

export const clearLegacyDataCaches = (): void => {
    for (const key of DATA_CACHE_KEYS) {
        try {
            localStorage.removeItem(key);
        } catch {
            // Storage can be unavailable in private browsing.
        }
    }
};
